import React from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledCollapse, NavbarBrand, Navbar, NavItem, NavLink, Nav, Container, Row, Col, Modal } from 'reactstrap';

import LoginPopup from 'modules/Auth/components/LoginPopup';
import RegisterStudentPopup from 'modules/Auth/components/RegisterStudentPopup';
import RegisterTeacherPopup from 'modules/Auth/components/RegisterTeacherPopup';
import withAuthenticator from 'HOCs/withAuthenticator';

const sachsoLogoUrl = require('assets/img/brand/sachso_logo.png').default;

const heid = window.location.hostname === 'heid.sachso.edu.vn';

function AuthNavbar() {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [countOpen_StudentModal, setCountOpen_StudentModal] = React.useState(0);
  const [modalTeacherVisible, setModalTeacherVisible] = React.useState(false);

  return (
    <div>
      <Modal isOpen={modalVisible} centered backdrop='static' backdropClassName='sachso-modal-backdrop' size='lg'>
        <LoginPopup
          onClose={() => {
            setModalVisible(false);
          }}
        />
      </Modal>
        <RegisterStudentPopup
          countOpen={countOpen_StudentModal}
          onBackLogin={() => {
            setModalVisible(true);
          }}
        />
      <Modal isOpen={modalTeacherVisible} centered backdrop='static' backdropClassName='sachso-modal-backdrop' size='md'>
        <RegisterTeacherPopup
          onClose={() => {
            setModalTeacherVisible(false);
          }}
        />
      </Modal>
      <Navbar style={{ boxShadow: '0px 4px 6px #E7E7E7' }} className='navbar-horizontal navbar-main navbar-dark navbar-transparent' expand='lg' id='navbar-main'>
        <Container>
          <NavbarBrand to='/' tag={Link}>
            <img alt='Sách số' src={sachsoLogoUrl} style={{ marginTop: -10 }} />
          </NavbarBrand>
          <button
            style={{ background: '#1179EF' }}
            aria-controls='navbar-collapse'
            aria-expanded={false}
            aria-label='Toggle navigation'
            className='navbar-toggler'
            data-target='#navbar-collapse'
            data-toggle='collapse'
            id='navbar-collapse'
            type='button'
          >
            <span className='navbar-toggler-icon' />
          </button>
          <UncontrolledCollapse className='navbar-custom-collapse' navbar toggler='#navbar-collapse'>
            <div className='navbar-collapse-header'>
              <Row>
                <Col className='collapse-brand' xs='6'>
                  <Link to='/'>
                    <img alt='Sách số' src={sachsoLogoUrl} style={{ marginTop: -8 }} />
                  </Link>
                </Col>
                <Col className='collapse-close' xs='6'>
                  <button aria-controls='navbar-collapse' aria-expanded={false} aria-label='Toggle navigation' className='navbar-toggler' data-target='#navbar-collapse' data-toggle='collapse' id='navbar-collapse' type='button'>
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            <Nav className='mr-auto' navbar>
              <NavItem>
                <NavLink className='nav-link' href='/'>
                  <span className='nav-link-inner--text' style={{ color: '#1179EF', fontSize: 14, fontWeight: 600 }}>
                    Trang chủ
                  </span>
                </NavLink>
              </NavItem>
              {!heid && (
                <NavItem>
                  <NavLink className='nav-link' href='https://phuongnam.edu.vn' target='_blank'>
                    <span className='nav-link-inner--text' style={{ color: '#1179EF', fontSize: 14, fontWeight: 600 }}>
                      Phương Nam
                    </span>
                  </NavLink>
                </NavItem>
              )}
              <NavItem>
                <NavLink
                  className='nav-link'
                  onClick={(e) => {
                    e.preventDefault();
                    setModalVisible(true);
                  }}
                >
                  <span className='nav-link-inner--text' style={{ color: '#1179EF', fontSize: 14, fontWeight: 600 }}>
                    Đăng nhập
                  </span>
                </NavLink>
              </NavItem>
              {/* {!heid && (
                <NavItem>
                  <NavLink className='nav-link' href='https://hanhtrangso.nxbgd.vn/' target='_blank'>
                    <span className='nav-link-inner--text' style={{ color: '#1179EF', fontSize: 14, fontWeight: 600 }}>
                      Kích hoạt sách điện tử
                    </span>
                  </NavLink>
                </NavItem>
              )} */}
              <NavItem>
                <NavLink
                  className='nav-link'
                  onClick={(e) => {
                    e.preventDefault();
                    setCountOpen_StudentModal(pre => pre + 1);
                  }}
                >
                  <span className='nav-link-inner--text' style={{ color: '#1179EF', fontSize: 14 ,fontWeight: 600}}>
                    Đăng ký học sinh
                  </span>
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  className='nav-link'
                  onClick={(e) => {
                    e.preventDefault();
                    setModalTeacherVisible(true);
                  }}
                >
                  <span className='nav-link-inner--text' style={{ color: '#1179EF', fontSize: 14 }}>
                    Đăng ký giáo viên
                  </span>
                </NavLink>
              </NavItem> */}
              {/* <NavItem>
                <a className='nav-link' href='https://hanhtrangso.nxbgd.vn' target='_blank' rel='noopener noreferrer'>
                  <span className='nav-link-inner--text' style={{ color: '#1179EF', fontSize: 14 }}>
                    Đăng ký giáo viên
                  </span>
                </a>
              </NavItem> */}
            </Nav>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default withAuthenticator(AuthNavbar);
